import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-20" data-mp="1cm7q2dl81zfo">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-21" data-mp="1citmj20tnk6n">
        <SectionTag icon="🎁" tone="accent" data-id="element-22" data-mp="18l5o3ozx79a0">
          6 Bonos exclusivos incluidos
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-23" data-mp="259bqs6da7rln">
          6 Bonos premium valorados en 114€ — incluidos gratis
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-5 px-4 sm:px-6 lg:grid-cols-2" data-id="element-24" data-mp="1w7udswv68616">
        {bonuses.map((bonus, i) => <m.div key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col rounded-2xl border-2 border-accent/30 bg-white p-6 shadow-card-light" data-id="element-25" data-mp="1rc6kc59noqpv" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-26" data-mp="1jror6k7zkuu1">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-accent/10 text-2xl" data-id="element-27" data-mp="15t8l8vhy78cy">
                <span aria-hidden="true" data-id="element-28" data-mp="1ar0fvx9z98ku">{bonus.emoji}</span>
              </div>
              <span className="text-sm" data-id="element-29" data-mp="w2nf8mzy31k0">
                <span className="text-danger line-through" data-id="element-30" data-mp="w1m7osi50x71">{bonus.value}</span>{' '}
                <span className="font-semibold text-success" data-id="element-31" data-mp="10uno54xzt4sq">GRATIS</span>
              </span>
            </div>
            <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-primary" data-id="element-32" data-mp="n423pbsw4msq">{bonus.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/80" data-id="element-33" data-mp="r4c6kfldyx3d">{bonus.text}</p>
            <ul className="mt-4 space-y-2" data-id="element-34" data-mp="d4tcgqpetma2">
              {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink" data-id="element-35" data-mp="i22ydwdlbft5">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-36" data-mp="2jtd6fubw8r5t" />
                  <span data-id="element-37" data-mp="2f0sekycjso4x">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}